<template>
  <div class="bg">
    <div class="top">
      <p class="text_1">¥{{money}}</p>
      <p class="text_2">本订单将于{{time}}关闭</p>
    </div>
    <div class="pay_aw">
      <label @click="payTab(0)">
        <i class="pay_radio" :class="payType == 0 ? 'active' : ''"></i>
        <i class="paywx"></i>
        <p class="text">微信</p>
      </label>
      <label @click="payTab(1)">
        <i class="pay_radio" :class="payType == 1 ? 'active' : ''"></i>
        <i class="payali"></i>
        <p class="text">支付宝</p>
      </label>
    </div>
    <div class="sure_pay" @click="surePay">
      <div v-if="spinner">确认支付</div>
      <div v-else style="display:flex;justify-content:center;align-items: center ;">
        <div>确认支付</div>
        <van-loading type="spinner" /></div>
    </div>
    <van-dialog v-model="show" title="您是否已完成支付" :showConfirmButton="false">
      <div class="dialog_div">
        <button class="buttonDialog" style="color:#b4272d;" @click="gopaysuess">已完成支付</button>
        <button class="buttonDialog" style="color:#CFD0D1;" @click="show=false">支付遇到问题，重新支付</button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { getWebAlipay, getWebWechatPay } from '../../request/api.js'
import { Toast, Dialog, Loading } from 'vant'

export default {
  components: {
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Dialog.Component.name]: Dialog.Component
  },
  name: 'pay',
  data () {
    return {
      id: '',
      money: '',
      time: '',
      show: true,
      spinner: true,
      payType: 0 // 0 微信  1 支付宝
    }
  },
  created () {
    var data = JSON.parse(sessionStorage.getItem('pay'))
    console.log(data)
    this.id = data.id
    this.money = data.money
    this.time = data.time
  },
  methods: {
    // 支付方式
    payTab (n) {
      console.log(n)
      this.payType = n
    },
    surePay () {
      // Toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // })
      this.spinner = false
      this.payCompo(this.payType, this.id)
      sessionStorage.setItem('payType', this.payType + '')
    },
    // 支付组件
    async payCompo (payType, orderSn) {
      var u = navigator.userAgent
      console.log(u)
      // const _this = this
      if (payType === 1) {
        // 支付宝支付
        const res = await getWebAlipay({
          out_trade_no: orderSn
        })
        console.log(res)
        if (res.code === 200) {
          // Toast.clear()
          const div = document.createElement('div')
          // /* 此处form就是后台返回接收到的数据 */
          div.innerHTML = res.data
          document.body.appendChild(div)
          document.forms[0].submit()
          this.spinner = true
        } else {
          setTimeout(() => {
            Toast.clear()
          }, 1000)
          Toast.fail('支付失败')
          this.spinner = true
        }
      } else {
        // 微信支付
        const res = await getWebWechatPay({
          out_trade_no: orderSn
        })
        console.log(res)
        if (res.code === 200) {
          window.location.href = res.data.mweb_url + '&redirect_url=' + 'https%3A%2F%2Fychd.soujingpin.com%2F%23%2Fpaycenter'
          this.spinner = true
          // window.open(res.data.mweb_url + '&' + 'redirect_url' + '=' + 'https://test.soujingpin.com/mobileterminal/#/pay')
          // "https://wx.tenpay.com/cgi-bin/mmpayweb-bin/checkmweb?prepay_id=wx281336559523838c803e811b1636217400&package=2836826275"
          // const router = _this.$router.resolve({
          //   path: 'paywx',
          //   query: {
          //     orderid: orderSn,
          //     result: res.data
          //   }
          // })
          // if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          //   // 安卓手机
          //   window.open(router.href, '_blank')
          // } else if (u.indexOf('iPhone') > -1) {
          //   // 苹果手机
          //   window.location.replace(router.href, '_blank')
          // } else if (u.indexOf('Windows Phone') > -1) {
          //   // winphone手机
          //   window.open(router.href, '_blank')
          // }
        } else {
          setTimeout(() => {
            Toast.clear()
          }, 1000)
          Toast.fail('支付失败')
          this.spinner = true
        }
      }
    },
    gopaysuess() {
      // console.log(this.$route.query)
      var query = sessionStorage.getItem('pay')
      this.$router.push({ path: '/paysuess', query: { query: query } })
    }
  }
}
</script>

<style lang="less" scoped>
@pierce: ~">>>";
@widthframe: 690px;
* {
  box-sizing: border-box;
}
.bg {
  min-height: 100vh;
  background: #f2f2f2;
}
.top {
  text-align: center;
  padding: 80px 0;
  .text_1 {
    font-size: 56px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .text_2 {
    color: #b4272d;
    font-size: 28px;
    padding-top: 20px;
  }
}
/* 支付方式 */
.pay_aw {
  width: 100%;
  padding-top: 50px;
  overflow: hidden;
}
.pay_aw label {
  float: left;
  width: 100%;
  padding: 25px 30px;
  border-bottom: solid 1px #eee; /*no*/
  background: #fff;
  cursor: pointer;
}
.pay_aw label i {
  float: left;
}
.pay_aw label i.pay_radio {
  height: 30px;
  width: 30px;
  margin-top: 5px;
  background-image: url("../../assets/images/icon_2.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.pay_aw label i.pay_radio.active {
  background-image: url("../../assets/images/icon_3.png");
}
.pay_aw label i.payali,
.pay_aw label i.paywx {
  height: 40px;
  width: 40px;
  margin: 0 12px 0 24px;
  background-repeat: no-repeat;
  background-size: cover;
}
.pay_aw label i.payali {
  background-image: url("../../assets/images/pic_33.png");
}
.pay_aw label i.paywx {
  background-image: url("../../assets/images/pic_34.png");
}
.pay_aw label .text {
  float: left;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}
.sure_pay {
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  font-size: 32px;
  color: rgba(255, 255, 255, 1);
  background: rgba(180, 39, 45, 1);
  position: fixed;
  bottom: 0;
}
.dialog_div{
  height: 200px;
}
/deep/.van-dialog__header{
  height: 50px !important;
  line-height: 30px;
  font-size: 29px;
}
.buttonDialog{
  width: 100%;
  height: 99px;
  background-color: #fff;
  border: none;
  border-top: 0.1px solid #F2F2F2; /*no*/
  font-size: 29px;
}
/deep/.van-loading {
  color: white;
}
/deep/ .van-loading__spinner{
  width: 32px;
  height: 32px;
  margin-left: 15px;
}
</style>
